<template>
  <header class="s-header">
    <div class="header__top">
      <HeaderLogoComponent />
      <SearchModalComponent />
    </div>
    <SidebarComponent />
  </header>
</template>

<script>
import SearchModalComponent from '@/components/SearchModalComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import HeaderLogoComponent from './HeaderLogoComponent.vue';

export default {
  components: {
    HeaderLogoComponent,
    SearchModalComponent,
    SidebarComponent,
  },
  setup() {
    return {};
  }
};
</script>

<style scoped>

</style>
